import { render } from "./DrivePublicItems.vue?vue&type=template&id=6dcd7b65&scoped=true&ts=true"
import script from "./DrivePublicItems.vue?vue&type=script&lang=ts"
export * from "./DrivePublicItems.vue?vue&type=script&lang=ts"

import "./DrivePublicItems.vue?vue&type=style&index=0&id=6dcd7b65&scoped=true&lang=sass"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dcd7b65"]])

export default __exports__